<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>


    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="/static/dashboard/assets/img/droner3.jpg"
             data-bg-overlay="#008cfa" data-overlay-opacity="0.3"
    >
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">
                    <b>AEROVIEWER FOR CONTRIBUTORS</b>
                </h1>
                <br>
                <div class="row" style="margin-left: 15px;margin-right: 15px">
                    <div class="col-md-3 col-sm-12"></div>
                    <a href="{window.contrib}/login" target="_blank"
                       class="btn btn-lg col-sm-12 col-md-3 btn-complete btn-cons m-t-20 p-t-20 p-b-20"
                       style="font-size: 1.3em;">Contributors sign in
                    </a>
                    <a href="{window.contrib}/register" target="_blank"
                       class="btn btn-lg col-sm-12 col-md-3 btn-complete btn-cons m-t-20 p-t-20 p-b-20"
                       style="font-size: 1.3em;">Contributors sign up
                    </a>
                </div>
            </div>
        </div>
    </section>


    <!-- Section Title -->
    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 block-title m-b-0">JOIN THE AEROVIEWER COMMUNITY AND

                    </p>
                    <p class="h2 m-t-5 light">
                        START MAKING REVENUES FROM YOUR WORK
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- End section title -->


    <!-- Contributors section#1 -->

    <section class="bg-master-lightest p-b-60 p-t-60">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <h5 class="block-title hint-text no-margin">Become an AEROVIEWER Contributor</h5>
                <div class="row">
                    <div class="col">
                        <h1 class="m-t-5">TOGETHER WE WILL MAKE AEROVIEWER THE PREFERRED SOURCE OF AERIAL VISUAL CONTENT</h1>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <div class="p-l-35 md-p-l-5">
                            <p>AeroViewer aims to become the preferred source of aerial visual
                                content around the world. <br><br> We will be very glad to offer your videos (and later this
                                year also photos) to interested Users and help you make revenues out of your work. We are
                                not asking for exclusivities or other terms and conditions that will degrade your
                                professional and commercial rights</p>
                            <p class="hint-text font-arial no-padding">
                                We will only ask you to upload your best professional work and to guarantee that you are the
                                true and legal owner
                                of the commercial rights of the content you are submitting to our Platform
                                and that your content is not abusing and does not violate the privacy rules.</p>
                        </div>
                        <div class="row">
                            <div class="col no-padding text-center">
                                <a href="{ window.contrib }/register" target="_blank">
                                    <button id="contributors-create-account" type="button" onclick=""
                                            class="btn btn-lg btn-complete btn-cons m-t-20 p-t-20 p-b-20"
                                            style="font-size: 1.3em">Create contributor's account
                                    </button>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </section>


    <!--    <section class="bg-master-lighter p-b-60 p-t-60">-->
    <!--        <div class="container">-->
    <!--            <div class="md-p-l-20 md-p-r-20 xs-no-padding">-->
    <!--                <h5 class="block-title hint-text no-margin">Become an AEROVIEWER Contributor</h5>-->
    <!--                <div class="row">-->
    <!--                    <div class="col">-->
    <!--                        <h1 class="m-t-5">TOGETHER WE WILL MAKE AEROVIEWER THE PREFERRED SOURCE OF AERIAL VISUAL CONTENT</h1>-->
    <!--                    </div>-->
    <!--                    <div class="col no-padding xs-p-l-15 xs-p-r-15">-->
    <!--                        <div class="p-l-35 md-p-l-5">-->
    <!--                            <p>AeroViewer aims to become the preferred source of aerial visual-->
    <!--                                content around the world. <br><br> We will be very glad to offer your videos (and later this-->
    <!--                                year also photos) to interested Users and help you make revenues out of your work. We are-->
    <!--                                not asking for exclusivities or other terms and conditions that will degrade your-->
    <!--                                professional and commercial rights</p>-->
    <!--                            <p class="hint-text font-arial no-padding">-->
    <!--                                We will only ask you to upload your best professional work and to guarantee that you are the-->
    <!--                                true and legal owner-->
    <!--                                of the commercial rights of the content you are submitting to our Platform-->
    <!--                                and that your content is not abusing and does not violate the privacy rules.</p>-->
    <!--                        </div>-->
    <!--                        <div class="row">-->
    <!--&lt;!&ndash;                            <div class="col no-padding text-center">&ndash;&gt;-->
    <!--&lt;!&ndash;                                <a href="{ window.contrib }/register" target="_blank">&ndash;&gt;-->
    <!--&lt;!&ndash;                                    <button type="button" onclick=""&ndash;&gt;-->
    <!--&lt;!&ndash;                                            class="btn btn-lg btn-primary btn-cons btn-rounded m-t-20 p-t-20 p-b-20"&ndash;&gt;-->
    <!--&lt;!&ndash;                                            style="font-size: 1.3em">Create contributor's account&ndash;&gt;-->
    <!--&lt;!&ndash;                                    </button>&ndash;&gt;-->
    <!--&lt;!&ndash;                                </a>&ndash;&gt;-->
    <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
    <!--                        </div>-->

    <!--                    </div>-->
    <!--                </div>-->

    <!--            </div>-->
    <!--        </div>-->
    <!--    </section>-->

    <section class="p-b-50 p-t-50 bg-master-darkest sm-no-margin"
             data-pages-bg-image="/static/web/assets/images/drone-image-2.jpg"
             data-bg-overlay="black" data-overlay-opacity="0.3" data-pages="parallax"
             style="background: url(/static/web/assets/images/drone-image-2.jpg) center 95.6618%;">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col">
                    <div class="col-xs-height col-middle">
                        <div class="text-center">
                            <!--                            <h4 class="text-white p-b-10">Contributor’s beta version will last until the end of June-->
                            <!--                                2019.-->
                            <!--                            </h4>-->
                            <h4 class="text-white p-b-10">
                                <strong>
                                    Sign up for free,  upload, tag, geo-tag, test your content and submit your content
                                    for final approval.
                                </strong>
                            </h4>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 0.3;"></div>
    </section>

    <!-- End of Contributors section#1 -->

    <!-- Contributors section#2 -->

    <section class="bg-master-lightest p-b-60 p-t-60">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <h5 class="block-title hint-text no-margin">WE PROVIDE INNOVATIVE FUNCTIONALITY</h5>
                <div class="row">
                    <div class="col">
                        <h1 class="m-t-5"> We offer the necessary environment, time and tools for you to experiment, master
                            and improve </h1>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <div class="p-l-35 md-p-l-5">
                            <p>AeroViewer is the first aerial video platform / bank to offer geo-referenced videos to the interested Users / Buyers. Thus, for the uploaded videos, we will offer you the tools and will ask you to geo-tag your videos and make them easily searchable and locatable using the Map. This will increase drastically the “search ability” of your content. Your video in order to become “approved” MUST HAVE at least one GPS position presenting the point on Earth your video has been captured (home port).</p>
                            <p class="hint-text font-arial no-padding">
                                AeroViewer is the first aerial video platform / bank that allows the User to tailor made his videos. The User can select and “cut” segments of a video instead of taking it all. And if he likes he can combine different contributors’ segments to create his own video. Thus, we ask you to upload single cut videos (NOT EDITED VIDEOS) and let the User to choose what is needed.</p>
                        </div>
                        <div class="row">
                            <!--<div class="col no-padding text-center">-->
                            <!--<a href="/partners/register">-->
                            <!--<button type="button" class="btn btn-lg btn-primary btn-cons btn-rounded m-t-20 p-t-20 p-b-20" style="font-size: 1.3em">View video tutorial-->
                            <!--</button>-->
                            <!--</a>-->
                        </div>
                    </div>

                </div>
            </div>

        </div>
        </div>
    </section>

    <section class="p-b-100 p-t-100 bg-master-darkest sm-no-margin"
             data-pages-bg-image="/static/web/assets/images/contributors-1.png"
             data-bg-overlay="black" data-overlay-opacity="0.5" data-pages="parallax"
             style="background: url(/static/web/assets/images/contributors-1.png) center 85.6618% ">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col">
                    <div class="col-xs-height col-middle">
                        <div class="text-center">
                            <h3 class="text-white p-b-10"><strong>
                                We Introduce some functions for the first time ever and we
                                believe that we have to provide to you the necessary environment
                                and tools in order to be able to experiment and master these new functions.
                            </strong>
                            </h3>

                            <h5 class="text-white"><b>
                                All the videos you will upload should be “finally-approved” by our
                                content team.
                            </b>
                            </h5>

                            <h5 class="text-white">
                                <b>
                                    If for some reason we will disapprove your material you will receive a report explaining
                                    the problems we have encountered and how you can correct them. We will also notify you
                                    and ask you to provide your banking account details in order to receive money coming
                                    from sales of your content
                                </b>
                            </h5>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 0.3;"></div>
    </section>

    <!-- End of Contributors section#1 -->

    <!-- Section Title -->
    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <h1 class="block-title m-b-0">BASIC RULES & GUIDELINES FOR VIDEO UPLOADING
                    </h1>
                </div>
            </div>
        </div>
    </section>

    <section class="p-b-85 p-t-55 p-b-65 p-t-55 bg-master-lightest">
        <div class="container">
            <div class="row md-p-l-20 xs-no-padding">
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <!--<img class="step-icons lazy loaded" src="/static/web/assets/images/step-1-cropped.png" alt="">-->
                        <h6 class="block-title p-b-5"><i class="fa fa-database" style="color: #10cfbd"></i> File Size</h6>
                        <p class="m-b-30">
                            Currently maximum file size is 8GB and video duration up to 2 minutes. For bigger duration you
                            have to contact the Content team at content@aroviewer.com
                        </p>
                    </div>
                </div>
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <!--<img class="step-icons lazy loaded" src="/static/web/assets/images/step-1-cropped.png" alt="">-->
                        <h6 class="block-title p-b-5"><i class="fa fa-file-video-o" style="color: #10cfbd"></i> Video
                            properties</h6>
                        <p class="m-b-30">
                            All uploaded videos must be single cut videos not edited at all, with no vertical or square
                            framing.
                            Minimum resolution is 720p, accepted Resolution standards are: 1280X720,
                            1920x1080, 2048x1080, 3840x2160, 4096x2160, 4096x2304.
                        </p>
                    </div>
                </div>
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <h6 class="block-title p-b-5"><i class="fa fa-envelope" style="color: #10cfbd"></i> Encode &
                            Enveloping</h6>
                        <p class="m-b-30"> We accept MOV, MPG, MP4, and AVI formats, and only ProRes and H.264 Codex
                            with no sound over. Use frame rate standards and do not convert your original
                            frame rate when uploading.</p>


                    </div>
                </div>
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <h6 class="block-title p-b-5"><i class="fa fa-edit" style="color: #10cfbd"></i> Platform Editing
                        </h6>
                        <p class="m-b-30">After uploading you will be asked to add title and keyword metadata to your files and the GPS position indicating either the starting of your flight path or the most characteristic point on
                            Earth your video is presenting or the point of Earth your story is using as scenery
                        </p>
                    </div>
                </div>

                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <h6 class="block-title p-b-5"><i class="fas fa-user-secret" style="color: #10cfbd"></i> Private Data
                            Policy
                        </h6>
                        <p class="m-b-30">Ask yourself if the person in the video would recognize
                            themselves or if the property owner would recognize their property.
                            If the answer is “Yes”, you may need a model release or a property release.
                            Especially if there is an identifiable property, investigate whether
                            the item is protected by privacy, trademark, or copyright law.
                            If yes, a property release may be required
                        </p>
                    </div>
                </div>
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <h6 class="block-title p-b-5"><i class="fa fa-thumbs-up" style="color: #10cfbd"></i> Quality
                            Standards
                        </h6>
                        <p class="m-b-30">For your videos to have commercial value, we expect them to be, appropriately lit
                            and exposed,
                            free of visual and audio noise, minimally processed, visually stable unless shakiness is
                            relevant to the content,
                            without noticeable wobble (known as “jello” artifacts) or flash banding.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col no-padding text-center">
                <a href="{ window.contrib }/register" target="_blank">
                    <button id="" type="button" onclick=""
                            class="btn btn-lg btn-complete btn-cons m-t-20 p-t-20 p-b-20"
                            style="font-size: 1.3em">GET STARTED NOW
                    </button>
                </a>
            </div>
        </div>

    </section>
    <!-- End section title -->

    <avr-footer></avr-footer>

    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/contributors/app.tag.html